export const FETCH_UPDATE = 'FETCH_UPDATE';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_FAILURE = 'FETCH_FAILURE';

export const FETCH_PASSWORD_DETAILS = 'FETCH_PASSWORD_DETAILS';
export const FETCH_PASSWORD_DETAILS_FAILURE = 'FETCH_PASSWORD_DETAILS_FAILURE';
export const FETCH_PASSWORD_DETAILS_SUCCESS = 'FETCH_PASSWORD_DETAILS_SUCCESS';

export const FETCH_CONFERENCE_CALL_DETAILS_SUCCESS = 'FETCH_CONFERENCE_CALL_DETAILS_SUCCESS';
export const FETCH_CONFERENCE_CALL_DETAILS_FAILURE = 'FETCH_CONFERENCE_CALL_DETAILS_FAILURE';
export const FETCH_CONFERENCE_CALL_DETAILS = 'FETCH_CONFERENCE_CALL_DETAILS';

export const FETCH_EVENT_BRANDING_SUCCESS = 'FETCH_EVENT_BRANDING_SUCCESS';
export const FETCH_EVENT_BRANDING_LOGOS_SUCCESS = 'FETCH_EVENT_BRANDING_LOGOS_SUCCESS';
export const FETCH_EVENT_BRANDING_INFO_SUCCESS = 'FETCH_EVENT_BRANDING_INFO_SUCCESS';
export const FETCH_EVENT_BRANDING_LOGOS_FETCH_LOADING_SUCCESS = 'FETCH_EVENT_BRANDING_LOGOS_FETCH_LOADING_SUCCESS';

export const FETCH_USER_REGISTRATION_DETAILS = 'FETCH_USER_REGISTRATION_DETAILS';
export const FETCH_USER_REGISTRATION_DETAILS_SUCCESS = 'FETCH_USER_REGISTRATION_DETAILS_SUCCESS';
export const FETCH_USER_REGISTRATION_DETAILS_FAILURE = 'FETCH_USER_REGISTRATION_DETAILS_FAILURE';

export const SAVE_NEW_USER = 'SAVE_NEW_USER';
export const SAVE_NEW_USER_SUCCESS = 'SAVE_NEW_USER_SUCCESS';
export const SAVE_NEW_USER_FAILURE = 'SAVE_NEW_USER_FAILURE';

export const FETCH_DISCLAIMERS = 'FETCH_DISCLAIMERS';
export const FETCH_DISCLAIMERS_FAILURE = 'FETCH_DISCLAIMERS_FAILURE';
export const FETCH_DISCLAIMERS_SUCCESS = 'FETCH_DISCLAIMERS_SUCCESS';

export const FETCH_DISCLAIMER_CONTENT = 'FETCH_DISCLAIMER_CONTENT';
export const FETCH_DISCLAIMER_CONTENT_FAILURE = 'FETCH_DISCLAIMER_CONTENT_FAILURE';
export const FETCH_DISCLAIMER_CONTENT_SUCCESS = 'FETCH_DISCLAIMER_CONTENT_SUCCESS';

export const REMOVE_FIRST_DISCLAIMER = 'REMOVE_FIRST_DISCLAIMER';

export const POST_CONFIRM_EMAIL = 'POST_CONFIRM_EMAIL';
export const POST_CONFIRM_EMAIL_SUCCESS = 'POST_CONFIRM_EMAIL_SUCCESS';
export const POST_CONFIRM_EMAIL_FAILURE = 'POST_CONFIRM_EMAIL_FAILURE';

export const POST_REGISTER_USER_SUCCESS = 'POST_REGISTER_USER_SUCCESS';

export const FETCH_LOGGED_IN_USER_DETAILS_SUCCESS = 'FETCH_LOGGED_IN_USER_DETAILS_SUCCESS';

export const FETCH_REGISTERED_USER_FOR_CALL_SUCCESS = 'FETCH_REGISTERED_USER_FOR_CALL_SUCCESS';

export const FAILURE_NOTIFICATION = 'FAILURE_NOTIFICATION';
export const SUCCESS_NOTIFICATION = 'SUCCESS_NOTIFICATION';

export const FETCH_USER_PERMISSION = 'FETCH_USER_PERMISSION';
export const FETCH_USER_PERMISSION_SUCCESS = 'FETCH_USER_PERMISSION_SUCCESS';
export const FETCH_USER_PERMISSION_FAILURE = 'FETCH_USER_PERMISSION_FAILURE';
export const SAVE_USER_CREDENTIALS = 'SAVE_USER_CREDENTIALS';
export const SHOW_SUCCESS_CONTENT = 'SHOW_SUCCESS_CONTENT';

export const UPDATE_ERROR_MESSAGE = 'UPDATE_ERROR_MESSAGE';
export const RESET_ERROR_MESSAGE = 'RESER_ERROR_MESSAGE';

export const FETCH_CONFERENCE_ACCESS_CODES_SUCCESS = 'FETCH_CONFERENCE_ACCESS_CODES_SUCCESS';
export const FETCH_CONFERENCE_ACCESS_CODES_FAILURE = 'FETCH_CONFERENCE_ACCESS_CODES_FAILURE';

export const FETCH_LIVESTREAM_URL = 'FETCH_LIVESTREAM_URL';
export const REPLAY_AUDIO_URL = 'REPLAY_AUDIO_URL';
export const SET_LIVESTREAM_PARTICIPANT_SESSION = 'SET_LIVESTREAM_PARTICIPANT_SESSION';

export const FETCH_TIME_DETAILS_SUCCESS = 'FETCH_TIME_DETAILS_SUCCESS';
export const FETCH_TIME_DETAILS_FAILURE = 'FETCH_TIME_DETAILS_FAILURE';
export const FETCH_TIME_DETAILS = 'FETCH_TIME_DETAILS';

export const FETCH_CONFERENCE_CALL_STATUS_SUCCESS = 'FETCH_CONFERENCE_CALL_STATUS_SUCCESS';
export const FETCH_CONFERENCE_CALL_STATUS_FAILURE = 'FETCH_CONFERENCE_CALL_STATUS_FAILURE';
export const FETCH_CONFERENCE_CALL_STATUS = 'FETCH_CONFERENCE_CALL_STATUS';

export const FETCH_USER_INFORMATION_SUCCESS = 'FETCH_USER_INFORMATION_SUCCESS';
export const FETCH_USER_INFORMATION_FAILURE = 'FETCH_USER_INFORMATION_FAILURE';

export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_FAILURE = 'FETCH_COUNTRIES_FAILURE';

export const SET_CONFERENCE_CALL_STATUS = 'SET_CONFERENCE_CALL_STATUS';
export const SET_ASSISTANCE_MESSAGE_STATUS = 'SET_ASSISTANCE_MESSAGE_STATUS';
export const SET_HAS_CONFERENCE_STARTED = 'SET_HAS_CONFERENCE_STARTED'

export const SET_PUBLIC_PARTICIPANT = 'SET_PUBLIC_PARTICIPANT';

export const SET_SALES_REP = 'SET_SALES_REP';
export const SET_PRIVACY_POLICY_FLAG = 'SET_PRIVACY_POLICY_FLAG';
export const SET_PRIVACY_POLICY_ERROR_MESSAGE = 'SET_PRIVACY_POLICY_ERROR_MESSAGE';

export const FETCH_CONFERENCE_CALL_ICS_FILE_SUCCESS = 'FETCH_CONFERENCE_CALL_ICS_FILE_SUCCESS';
export const FETCH_CONFERENCE_CALL_ICS_FILE_FAILURE = 'FETCH_CONFERENCE_CALL_ICS_FILE_FAILURE';
export const FETCH_CONFERENCE_CALL_ICS_FILE = 'FETCH_CONFERENCE_CALL_ICS_FILE';

export const FETCH_GLOBAL_NUMBERS_SUCCESS = 'FETCH_GLOBAL_NUMBERS_SUCCESS';
export const FETCH_GLOBAL_NUMBERS_FAILURE = 'FETCH_GLOBAL_NUMBERS_FAILURE';

export const FETCH_USER_STATUS_SUCCESS = 'FETCH_USER_STATUS_SUCCESS';
export const FETCH_USER_STATUS_FAILURE = 'FETCH_USER_STATUS_FAILURE';

export const SET_RETRIEVED_QUESTION = 'SET_RETRIEVED_QUESTION';
export const FETCH_QUESTIONS_FAILURE = 'FETCH_QUESTIONS_FAILURE';
export const SUBMIT_QUESTION_FAILURE = 'SUBMIT_QUESTION_FAILURE';
export const UPDATE_QUESTION_FAILURE = 'UPDATE_QUESTION_FAILURE';
export const DELETE_QUESTION_FAILURE = 'DELETE_QUESTION_FAILURE';

export const SET_MISSING_INFO_STATUS = 'SET_MISSING_INFO_STATUS';
export const COMPLETE_PROFILE_SUCCESS = 'COMPLETE_PROFILE_SUCCESS';
export const COMPLETE_PROFILE_FAILURE = 'COMPLETE_PROFILE_FAILURE';

export const CREATE_USER_SESSION_SUCCESS = 'CREATE_USER_SESSION_SUCCESS';
export const RESEND_MAIL_SUCCESS = 'RESEND_MAIL_SUCCESS';

export const FETCH_RELEASE_INFO = 'FETCH_RELEASE_INFO';
export const SET_USER_PRIMARY_EMAIL = 'SET_USER_PRIMARY_EMAIL';

export const FETCH_ACCOUNT_TYPES_SUCCESS = 'FETCH_ACCOUNT_TYPES_SUCCESS';
export const FETCH_ACCOUNT_TYPES_FAILURE = 'FETCH_ACCOUNT_TYPES_FAILURE';
export const FETCH_COMPANY_ROLES_SUCCESS = 'FETCH_COMPANY_ROLES_SUCCESS';
export const RESET_COMPANY_ROLES_ON_LANG_CHANGE = 'RESET_COMPANY_ROLES_ON_LANG_CHANGE';
export const FETCH_COMPANY_ROLES_FAILURE = 'FETCH_COMPANY_ROLES_FAILURE';

export const SET_PRESENTER_REG_BYPASS = 'SET_PRESENTER_REG_BYPASS';

export const FETCH_COMPANY_SUGGESTIONS_SUCCESS = 'FETCH_COMPANY_SUGGESTIONS_SUCCESS';
export const FETCH_COMPANY_SUGGESTIONS_FAILURE = 'FETCH_COMPANY_SUGGESTIONS_FAILURE';
export const FETCH_UTC_TIME_STRING = 'FETCH_UTC_TIME_STRING';

export const SET_IS_USER_PRESENTER = 'SET_IS_USER_PRESENTER';
export const SET_PRIVACY_CONSENT_DATA = 'SET_PRIVACY_CONSENT_DATA';